/**
 * Created by Ganesh.Sharma on 31-08-2016.
 */

define(['edge/platform/base/BaseCtrl','edge/platform/modelvalidation/FormUtil'], (BaseCtrl ,FormUtil )=> {
    const fn =($scope, $stateParams, $state, submissionViewModel , ModalService, $q, StateUtils)=> {
    const ctrl = Object.create(BaseCtrl);
    const flowModel = StateUtils.activeDataForState(true).flowModel;
    const submissionVM = submissionViewModel();

ctrl.init = ()=> {
    
    // Residence Type List Filter Code
    $scope.residenceTypeIgnoreList = ["Fam2", "Fam3", "Fam4", "Fam5", "Coop", "Quadplex_aaa", "Triplex_aaa", "Apt","rowhouse_aaa"];

    $scope.view = submissionVM.draftData.lobs.homeowners.additionalInfo;
    $scope.view.value = $scope.view.value || {};
    //HO4 means it is rented house
    //HO6 and HO3 means own house selected
    if( $scope.view.homeType.value === "HO4" )
    {
        $scope.view.homeType.value = 500
    } else if ( $scope.view.homeType.value === "HO6" || $scope.view.homeType.value === "HO3"){
        $scope.view.homeType.value = 1500
    }
    
     $scope.view.homeOccupationInMonths.value = 0;
     $scope.protectionClass = submissionVM.draftData.lobs.homeowners.protectionClass.value;

};

//This is to send default value to PC temporarily.
function setToDefault(model) {
    if (!model.value) {
        model.value = model.aspects.availableValues[0];
    }
};


ctrl.homeTypeClick = function(){
    if($scope.view.homeType.value===500)
    {
        setToDefault($scope.view.residenceType);
        $scope.view.value.bestDescribeHome = "owner";
    }
    else if($scope.view.homeType.value===1500)
    {
        $scope.view.value.residenceType = undefined;
        $scope.view.value.bestDescribeHome = undefined;

    }
} ;



ctrl.next = (form)=> {
//$scope.view.homeType.value.$dirty &&
//console.log("inside additional info next");
//CHG0034024-ISO PPC Trigger Changes adding validation
if($scope.protectionClass){
                $scope.view.distanceToFireStation = 3;
            }
    form.submitted = true;
    if( $scope.view.homeType.value === 500 ){
        $scope.view.homeType.value = "HO4";
        
    }
    else if ( $scope.view.homeType.value === 1500 )
    {
        if($scope.view.residenceType.value.code === "Condo"){
            $scope.view.homeType.value = "HO6";
        }else{
            $scope.view.homeType.value = "HO3";
        }
    }
    
    // Set form type value
    $scope.view.formType.value = $scope.view.homeType.value;
    

    // Test code
    
    //$scope.view.homeOccupationInMonths.value = 1;

   /* nextFn(submissionVM);*/

   
    //This is used to hold the selected value of home type when there is an error in input
    if(!submissionVM.draftData.lobs.homeowners.aspects.subtreeValid){
        if ($scope.view.homeType.value === "HO4"){
            $scope.view.homeType.value = 500;}
        else if ($scope.view.homeType.value === "HO3" || $scope.view.homeType.value === "HO6"){
            $scope.view.homeType.value = 1500;}
    }else{
        flowModel.next(submissionVM);
    }
};

ctrl.cancel = function () {
    flowModel.cancel(submissionVM);
};

ctrl.defineWatches = ()=> {
    $scope.$watch('view.bankruptcyInfo.value', ()=>{
        if($scope.view.bankruptcyInfo.value){
           /*var resp = const errorPromise = ModalService.showError(
                'quoteandbind.ho.views.addinfo.Attention',
                'quoteandbind.ho.views.addinfo.Bankruptcy Error Message'
            ).result;*/
            $state.go('contactUs');
        }
    });
}



return ctrl.create($scope);
};
fn.$inject = ['$scope', '$stateParams', '$state', 'submissionViewModel','ModalService', '$q', 'StateUtils'];

return fn;
});




/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/quoteandbind/ho/controllers/HOAdditionalInfoCtrl.js
 **/